import { createApp } from 'vue'
import Hours from './Hours.vue'
import './assets/global.css'

createApp(Hours).mount('#hours')
